import React from "react";

import Heading from "../../../../components/atoms/heading";
import Card from "../../../../components/molecules/Card";
import HighlightSectionName from "../../../../shared/components/highLightSectionName";

import rightTickImg from "../../../../assets/images/rightTick.svg";

import styles from "./benefits.module.scss";

const Benefits = (props) => {
  return (
    <div className="body-container">
      <div className={styles.container}>
        <div className={styles.highlightSectionWrapper}>
          <HighlightSectionName text="HOW IT WORKS" />
        </div>
        <Heading
          text="WHY UPSOLV"
          className={styles.heading}
        />
        <p className={styles.subHeading}>Be incharge of your career and prepare yourself against layoffs</p>
        <div className={styles.benefitItems}>
          <Card className={styles.card}>
            <Card.Image src={rightTickImg} className={styles.cardImage} />
            <div className={styles.cardContentWrapper}>
              <Card.Heading
                text="3 month unemployment allowance"
                className={styles.cardHeading}
              />
              <Card.Text text="on job loss" className={styles.cardText} />
            </div>
          </Card>
          <Card className={styles.card}>
            <Card.Image src={rightTickImg} className={styles.cardImage} />
            <div className={styles.cardContentWrapper}>
              <Card.Heading text="₹999/year plans" className={styles.cardHeading} />
              <Card.Text
                text="affordable for everyone"
                className={styles.cardText}
              />
            </div>
          </Card>
          <Card className={styles.card}>
            <Card.Image src={rightTickImg} className={styles.cardImage} />
            <div className={styles.cardContentWrapper}>
              <Card.Heading
                text="Premium portal subscriptions"
                className={styles.cardHeading}
              />
              <Card.Text
                text="for 3 months"
                className={styles.cardText}
              />
            </div>
          </Card>
          <Card className={styles.card}>
            <Card.Image src={rightTickImg} className={styles.cardImage} />
            <div className={styles.cardContentWrapper}>
              <Card.Heading
                text="Recruitment Assistance"
                className={styles.cardHeading}
              />
              <Card.Text
                text="profile building & interview preparation"
                className={styles.cardText}
              />
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
